import type { Event as AnalyticsEvent } from "@amplitude/analytics-types";
import React from "react";
import { useHotkeys } from "react-hotkeys-hook";
import BuildProgressSnackbar from "./BuildProgressSnackbar";
import { DevDrawer } from "./DevDrawer";
import DevOnly from "./DevOnly";
import { useDevToolsDispatch, actions, useDevToolsState } from "./DevToolsContext";
interface DevToolsProps {
    analyticsEvents: AnalyticsEvent[];
}
export const DevTools: React.FC<DevToolsProps> = ({ analyticsEvents }) => {
    const dispatcher = useDevToolsDispatch();
    const stateContext = useDevToolsState();
    const open = stateContext?.drawer.open || false;
    const fullscreen = stateContext?.drawer.fullscreen || false;
    useHotkeys("ctrl+shift+`", () => dispatcher?.dispatch(actions.toggleDrawer()), {
        enableOnFormTags: ["INPUT", "SELECT", "TEXTAREA"],
    }, []);
    return (<React.Fragment>
            <DevOnly>
                <BuildProgressSnackbar />
            </DevOnly>
            <DevDrawer open={open} onRequestClose={() => dispatcher?.dispatch(actions.closeDrawer())} fullscreen={fullscreen} onToggleFullscreen={() => dispatcher?.dispatch(actions.toggleFullscreen())} analyticsEvents={analyticsEvents}/>
        </React.Fragment>);
};
DevTools.displayName = "DevTools"
export default DevTools;
